// extracted by mini-css-extract-plugin
export default {"badgeFilter":"FilterBadge_badgeFilter__SlUqX","btn":"FilterBadge_btn__unxxS","btnIcon":"FilterBadge_btnIcon__hdpOX"};